import COLORS from '@/constants/colors';
import { Box, Paper, Typography } from '@mui/material';
import { TotalTicketUi } from './CartUiModel';

export const TotalTicket = ({
  totalTicket,
}: {
  totalTicket: TotalTicketUi;
}) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.white,
        border: `1px solid ${COLORS.gray_200}`,
        borderRadius: '12px',
        padding: '16px',
        boxShadow: 'none',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          color: COLORS.gray_800,
          fontSize: '12px',
          marginBottom: '12px',
        }}
      >
        Total de pedido
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '16px',
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            color: COLORS.gray_800,
            fontSize: '12px',
          }}
        >
          Total
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            color: COLORS.gray_800,
            fontSize: '12px',
          }}
        >
          ${totalTicket.total}
        </Typography>
      </Box>
    </Paper>
  );
};
